import { BaseCreateComponent } from "../../BaseCreateComponent";
import template from "./template.html";

class LoaderComponent extends BaseCreateComponent<HTMLDivElement> {
  private _logoRoute: string | null = null;

  public setLogoRoute(logoRoute: string) {
    this._logoRoute = logoRoute;
  }

  //

  protected getTagName(): string {
    return "div";
  }

  protected getElementId(): string {
    return "loadWrapper";
  }

  protected override afterInit(element: HTMLDivElement): void {
    if (!this._logoRoute) {
      throw new Error(
        "Debe llamar LoaderComponent.setLogoRoute(logoRoute: string)",
      );
    }
    //
    element.innerHTML = this.createHtmlString(template, {
      logo: this._logoRoute,
    });
  }
}

export const loaderComponent = new LoaderComponent();
